import { Button, Card, message, Space, Table, Typography } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../../server";
import ProductPacketItem from "./product-packet-item";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import { isMobile } from "@/extensions/design";
import "./product.css";

const { Text } = Typography;

const ProductPacket = ({id, onClose}) => {
  const [loading, setLoading] = useState(false)
  const [items, setItems] = useState([])
  const [selected, setSelected] = useState(null);

  const getData = () => {
    setLoading(true);
    serverFetch(`product/CntList/${id}`)
      .then(data => {
        setItems(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, [id])

  const columns = [
    { title: "Наименование", dataIndex: "productName" },
    { title: "Единица", dataIndex: "productExpUnit" },
    { title: "Количество", dataIndex: "qty" },
  ]

  const onItemClose = (refresh) => {
    setSelected([]);
    refresh ? getData() : setItems(items.filter(i => i.id));
  }

  const onRowClick = (record) => {
    setSelected(record.id === selected ? null : record.id);
  }

  const onAdd = () => {
    setItems([...items.filter(i => i.id), {mainProductId: id, qty: 1, id: 0}]);
    setSelected(0);
  }

  return !isMobile ? <div className="sport-section">
    <Space><Button onClick={onAdd}>Добавить</Button></Space>
    <Table
      columns={columns} size="small" dataSource={items} loading={loading} pagination={false} rowKey="id"
      expandable={{
        expandedRowRender: (record) => <ProductPacketItem onClose={onItemClose} itemDefault={record} />, expandedRowKeys: [selected],
        onExpand: (expanded, record) => setSelected(expanded ? record.id : null),
        expandIcon: ({ expanded, onExpand, record }) => expanded ? <DownOutlined onClick={(e) => onExpand(record, e)} /> : <RightOutlined onClick={(e) => onExpand(record, e)} />,
        rowExpandable: () => true,
        className: "cl-abons-expandable",
      }}
      onRow={record => ({ onClick: () => onRowClick(record) })}
      rowSelection={{ type: 'radio', selectedRowKeys: [selected], renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
    />
  </div> :
  <div className="product-mobile-container">
      <div className="product-mobile-actions">
        <Button style={{width: "100%"}} onClick={onAdd}>Добавить</Button>
      </div>
      <div className="product-mobile-scroll">
        {items.map(item => {
          const isExpanded = selected === item.id;
          return (
            <Card key={item.id} className="product-packet-card-mobile" style={{ borderLeft: '4px solid #1677ff' }} onClick={() => onRowClick(item)}>
              <div className="product-packet-card-row1-mobile">
                <Text strong>{item.productName || 'Новый'}</Text>
                <Text>Кол-во: {item.qty}</Text>
              </div>
              <div style={{ maxHeight: isExpanded ? 400 : 0, opacity: isExpanded ? 1 : 0 }} className="product-packet-card-expand-mobile">
                {isExpanded && <div onClick={e => e.stopPropagation()}><ProductPacketItem onClose={onItemClose} itemDefault={item} /></div>}
              </div>
            </Card>
          );
        })}
        {items.length === 0 && !loading && <div className="product-packet-empty-mobile">Нет данных</div>}
      </div>
    </div>
}

export default ProductPacket